// no-results.tsx
import { Tile } from '@carbon/react';
import { EmptyState } from 'components/empty-state';
import NoDataSvg from 'images/srp-illustration-data.svg';

interface NoResultsProps {
  headerText?: string;
  helperText?: string;
}

const NoResults = ({
  headerText = 'No Records Found',
  helperText = 'Currently Insights doesn’t have any available data.',
}: NoResultsProps) => {
  return (
    <Tile>
      <EmptyState
        icon={NoDataSvg}
        headerText={headerText}
        helperText={helperText}
      />
    </Tile>
  );
};

export { NoResults };
